import './App.css';
import { Route, Switch } from "react-router-dom";
import HomePage from './pages/Home.page';
import AdminPage from './pages/Admin.page';
import { useEffect, useRef, useState, useCallback } from 'react';
import { Box, AppBar, Toolbar, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Link, Button } from '@material-ui/core'
import axios from 'axios';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { CircleFlag } from 'react-circle-flags'
import { translations } from './i18n/i18n';

const theme = createTheme({
	palette: {
		primary: {
			main: '#7F2122',
		},
		secondary: {
			main: '#254e91',//254e91
		}
	},
	overrides: {
		MuiCheckbox: {
			root: {
				padding: '5px',
				margin: '0 2px 0 4px',
			},
		},
		MuiFormControlLabel: {
			label: {
				fontSize: '0.9rem',
			}
		}
	},
});  

const FrontendWrapper = () => {
	const [appData, setAppData] = useState(false);
	const [isError, setIsError] = useState(false);
	const [impressumOpen, setImpressumOpen] = useState(false);
	const loaderEl = useRef();

	useEffect(() => {
		axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/map/getMapData`, { headers: { 'Accept-Language': translations.getLanguage(), 'X-Requested-With': 'XMLHttpRequest' } }).then(response => {
			setAppData(response.data);
		}).catch(err => {
			setIsError(true);
		});
	}, []);

	const onInitialized = useCallback(() => {
		loaderEl.current.classList.remove("pageload-loading");
		loaderEl.current.classList.add("scale");

		setTimeout(function() {
			loaderEl.current.remove();
		}, 2000);
	}, []);

	if(isError) {
		return <div className="error-container">
			<Typography variant="h2">{translations.app.loadingError}</Typography>
		</div>;
	} else {
		return <ThemeProvider theme={theme}>
			<Dialog onClose={() => setImpressumOpen(false)} open={impressumOpen}>
				<DialogTitle>{translations.app.impressum}</DialogTitle>
				<DialogContent>
					<DialogContentText>{appData && appData.settings[`impressum_${translations.getLanguage()}`]}</DialogContentText>
					<DialogActions>
						<Button onClick={() => setImpressumOpen(false)} color="secondary">{translations.app.close}</Button>
					</DialogActions>
				</DialogContent>
			</Dialog>
			<div className="App">
				<AppBar position="static">
					<Toolbar>
						<Typography variant="h6">
							{appData && appData.settings[`page_title_${translations.getLanguage()}`]}
						</Typography>
						<Box flexGrow={1}></Box>
						{translations.getLanguage() != 'en' && <IconButton
							color="primary"
							onClick={() => {
								localStorage.setItem('locale', 'en');
								window.location.reload();
							}}>
							<CircleFlag countryCode="gb" height="32" title="English" cdnUrl={process.env.REACT_APP_CUSTOM_CDN_URL ? process.env.REACT_APP_CUSTOM_CDN_URL+'/flags/' : undefined} />
						</IconButton>}
						{translations.getLanguage() != 'hu' && <IconButton
							color="primary"
							onClick={() => {
								localStorage.setItem('locale', 'hu');
								window.location.reload();
							}}>
							<CircleFlag countryCode="hu" height="32" title="Magyar" cdnUrl={process.env.REACT_APP_CUSTOM_CDN_URL ? process.env.REACT_APP_CUSTOM_CDN_URL+'/flags/' : undefined} />
						</IconButton>}
						{translations.getLanguage() != 'de' && <IconButton
							color="primary"
							onClick={() => {
								localStorage.setItem('locale', 'de');
								window.location.reload();
							}}>
							<CircleFlag countryCode="de" height="32" title="Deutsch" cdnUrl={process.env.REACT_APP_CUSTOM_CDN_URL ? process.env.REACT_APP_CUSTOM_CDN_URL+'/flags/' : undefined} />
						</IconButton>}
					</Toolbar>
				</AppBar>

				<div id="loader" className={"pageload-overlay pageload-loading"} ref={loaderEl}>
					<svg id="svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1366 768">
						<path d="M0-0.617v768h1366v-768H0z M690.749,383.98c-1.186,0.793-2.958,2.867-4.583,2.331l-1.636-0.37
						c-0.328-0.075-0.654,0.13-0.729,0.458c-0.062,0.415-0.404,1.168-0.074,1.544l2.169,3.075c0.207,0.294-0.003,0.699-0.362,0.699
						c-0.467-0.038-1.299,0.135-1.643-0.289c0,0-0.379-0.378-0.864-0.86c-1.789,1.221-4.056,1.561-6.146,0.886l-0.636-0.205
						c-0.263-0.084-0.34-0.419-0.142-0.611c1.604-1.332,1.319-3.916,1.317-5.766c-0.017-2.165,1.008-3.753,2.451-4.687l-0.64-1.156
						c-0.717,0.48-1.349,1.095-1.858,1.828c-0.176,0.268-0.479,0.039-0.695-0.108c-0.034-0.022-0.071-0.045-0.111-0.071
						c-0.519-0.33-1.476-0.94-1.476-0.94c-0.839-0.624,2.565-3.251,3.192-3.514c0.557-0.419,4.727-1.952,4.819-0.885c0,0,0,1.232,0,1.75
						c0,0.001,0,0.001,0,0.001c0,0.038,0,0.103,0,0.129c0.009,0.262,0.039,0.643-0.282,0.646c-0.77,0.031-1.518,0.187-2.217,0.455
						l0.666,1.203c2.28-0.743,5.005-0.17,6.483,1.932c0.146-0.183,0.241-0.302,0.241-0.302c0.249-0.313,0.715-0.343,1.003-0.065
						l1.814,1.749C691.141,383.158,691.112,383.698,690.749,383.98z"/>
					</svg>
				</div>

				<div className="container">
					<Route exact path={["/:placeId?", "/:placeId?-:slug?"]}>
						{appData && <HomePage data={appData} onInitialized={onInitialized} />}
					</Route>
				</div>	

				<div className="footer">
					{appData && appData.settings[`footer_text_${translations.getLanguage()}`]} | <Link underline="hover" color="text" onClick={() => setImpressumOpen(true)}>{translations.app.impressum}</Link>
				</div>	
			</div>
		</ThemeProvider>;
	}
};

function App() {
	return (
		<Switch>
			<Route path="/admin">
				<AdminPage />
			</Route>
			<FrontendWrapper />
		</Switch>
	);
}

export default App;
